'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

export default function ForYouPage() {
	const router = useRouter();

	useEffect(() => {
		router.push('/for_you/curiosity');
	}, [router]);

	return null;
}
